module.exports = __webpack_public_path__ + "img/blue_box.49a73ce6.png";